import React, { Component } from 'react';

import AuthService from './AuthService';
import constants from '../config';

const Auth = new AuthService();

var NOTIFICATION_OPTIONS = [
  { key: 'purchaseConfirmation', icon: 'fa-shopping-cart', title: 'Purchase Confirmations', description: 'Emails when you buy an item' },
  { key: 'saleNotification', icon: 'fa-dollar', title: 'Sale Notifications', description: 'Emails when someone buys your listing' },
  { key: 'offerReceived', icon: 'fa-tag', title: 'Offers Received', description: 'Emails when someone makes an offer on your listing' },
  { key: 'offerResponse', icon: 'fa-reply', title: 'Offer Responses', description: 'Emails when a seller responds to your offer' },
  { key: 'shippingUpdates', icon: 'fa-truck', title: 'Shipping Updates', description: 'Emails about shipping and delivery status' },
  { key: 'priceDropAlerts', icon: 'fa-arrow-down', title: 'Price Drop Alerts', description: 'Emails when items you follow drop in price' },
  { key: 'marketing', icon: 'fa-envelope', title: 'Marketing & Promotions', description: 'Promotional emails, newsletters, and platform updates' },
];

class NotificationSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prefs: {},
      savedPrefs: {},
      loading: true,
      saving: false,
    };
    this.fetchPrefs = this.fetchPrefs.bind(this);
    this.savePrefs = this.savePrefs.bind(this);
  }

  componentDidMount() {
    this.fetchPrefs();
  }

  fetchPrefs() {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/users/' + this.props.user._id, {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      var p = (res.profile && res.profile.notificationPreferences) || {};
      // Apply defaults for missing keys
      var prefs = {};
      NOTIFICATION_OPTIONS.forEach(function(opt) {
        prefs[opt.key] = p[opt.key] !== undefined ? p[opt.key] : (opt.key === 'marketing' ? false : true);
      });
      self.setState({ prefs: prefs, savedPrefs: JSON.parse(JSON.stringify(prefs)), loading: false });
    }).catch(function(err) {
      console.log(err);
      self.setState({ loading: false });
    });
  }

  savePrefs() {
    var self = this;
    this.setState({ saving: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/users/notifications/preferences', {
      mode: 'cors',
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(this.state.prefs),
    }).then(function(res) {
      var saved = res.notificationPreferences || self.state.prefs;
      self.setState({ savedPrefs: JSON.parse(JSON.stringify(saved)), prefs: saved, saving: false });
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Notification preferences saved!', type: 'success' } }));
    }).catch(function(err) {
      console.log(err);
      self.setState({ saving: false });
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to save preferences', type: 'error' } }));
    });
  }

  hasChanges() {
    var prefs = this.state.prefs;
    var saved = this.state.savedPrefs;
    return NOTIFICATION_OPTIONS.some(function(opt) {
      return prefs[opt.key] !== saved[opt.key];
    });
  }

  render() {
    var self = this;
    var cardClass = 'tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-p-6 tw-mb-6';
    var cardStyle = { border: '1px solid #e0e0e0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' };
    var hasChanges = this.hasChanges();

    if (this.state.loading) {
      return (
        <div className="tw-flex tw-items-center tw-justify-center tw-py-12">
          <div className="tw-animate-spin tw-rounded-full tw-h-8 tw-w-8 tw-border-t-2 tw-border-b-2 tw-border-brand-gold"></div>
        </div>
      );
    }

    return (
      <div>
        <div className={cardClass} style={cardStyle}>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-2">Email Notifications</h3>
          <p className="tw-text-sm tw-text-[#888] tw-mb-6">Choose which emails you'd like to receive.</p>

          <div className="tw-space-y-1">
            {NOTIFICATION_OPTIONS.map(function(opt) {
              var enabled = self.state.prefs[opt.key];
              return (
                <div
                  key={opt.key}
                  className="tw-flex tw-items-center tw-justify-between tw-py-4 tw-px-3 tw-rounded-lg hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#0f0f0f] tw-transition-colors"
                  style={{ borderBottom: '1px solid #e0e0e020' }}
                >
                  <div className="tw-flex tw-items-center tw-gap-4 tw-flex-1">
                    <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ backgroundColor: enabled ? 'rgba(201,168,76,0.1)' : '#f5f5f5' }}>
                      <i className={'fa ' + opt.icon + ' tw-text-lg'} style={{ color: enabled ? '#c9a84c' : '#888' }}></i>
                    </div>
                    <div>
                      <p className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">{opt.title}</p>
                      <p className="tw-text-xs tw-text-[#888] tw-mt-0.5">{opt.description}</p>
                    </div>
                  </div>
                  <button
                    onClick={function() {
                      var updated = Object.assign({}, self.state.prefs);
                      updated[opt.key] = !enabled;
                      self.setState({ prefs: updated });
                    }}
                    className="tw-relative tw-w-11 tw-h-6 tw-rounded-full tw-border-none tw-cursor-pointer tw-transition-colors tw-flex-shrink-0"
                    style={{ backgroundColor: enabled ? '#c9a84c' : '#d1d5db' }}
                    aria-label={'Toggle ' + opt.title}
                  >
                    <span
                      className="tw-absolute tw-top-0.5 tw-w-5 tw-h-5 tw-rounded-full tw-bg-white tw-shadow tw-transition-transform"
                      style={{ left: enabled ? '22px' : '2px' }}
                    ></span>
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Save Bar */}
        {hasChanges ? (
          <div className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-z-50 tw-bg-white dark:tw-bg-[#1a1a1a] tw-py-3 tw-px-4" style={{ borderTop: '1px solid #e0e0e0', boxShadow: '0 -2px 12px rgba(0,0,0,0.1)' }}>
            <div className="tw-max-w-6xl tw-mx-auto tw-flex tw-items-center tw-justify-between">
              <span className="tw-text-sm tw-text-[#888]">
                <i className="fa fa-circle tw-text-brand-gold tw-text-[8px] tw-mr-2" style={{ verticalAlign: 'middle' }}></i>
                Unsaved changes
              </span>
              <button
                onClick={this.savePrefs}
                disabled={this.state.saving}
                className="tw-px-8 tw-py-2.5 tw-rounded-lg tw-bg-brand-gold tw-text-white tw-font-semibold tw-text-sm tw-border-none tw-cursor-pointer hover:tw-bg-brand-gold/90 tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              >
                {this.state.saving ? 'Saving...' : 'Save Preferences'}
              </button>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default NotificationSettings;
